import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.string.starts-with";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../services/apiService';
import { kebabCaseToCamelCase } from '../../utils/vuex';
import tenantPickerMixin from '../../components/core/tenant/pickerMixin';
import mergeWith from 'lodash/mergeWith';
import cloneDeep from 'lodash/cloneDeep';
import { themeDefaults, themeColors } from '../../utils/themes';
import { templateVariables } from '../../utils/emailTemplateVariables';
import routerPaths from '../../router/paths';
import set from 'lodash/set';
import get from 'lodash/get';

var mergeWithReplaceArrays = function mergeWithReplaceArrays(objValue, srcValue) {
  if (Array.isArray(objValue)) {
    return srcValue;
  }
};

var emailTemplatesOrder = [{
  template: 'is-fm-access-created',
  permissions: {
    subject: 'IsFmTicket',
    action: 'create'
  }
}, {
  template: 'is-fm-access-revoked',
  permissions: {
    subject: 'IsFmTicket',
    action: 'create'
  }
}, {
  template: 'password-changed'
}, {
  template: 'password-reset'
}, {
  template: 'ticket-created',
  permissions: {
    subject: 'IsFmTicket',
    action: 'create'
  }
}, {
  template: 'ticket-created-manager',
  permissions: {
    subject: 'IsFmTicket',
    action: 'create'
  }
}, {
  template: 'user-create-password-reset'
}, {
  template: 'user-locked'
}, {
  template: 'tenant-bridge-connectionerror'
}];
export default {
  name: 'ViewAccountMgmtAccountMgmtSettings',
  mixins: [tenantPickerMixin],
  data: function data() {
    return {
      emailTemplates: {},
      formIsValid: false,
      isSaving: false,
      imageUploads: {},
      colors: themeColors,
      themeDefaults: _objectSpread(_objectSpread({}, themeDefaults), {}, {
        domains: [],
        footerDE: {
          imprintUrl: '',
          aboutUsUrl: '',
          copyrightText: '',
          copyrightUrl: ''
        },
        footerEN: {
          imprintUrl: '',
          aboutUsUrl: '',
          copyrightText: '',
          copyrightUrl: ''
        }
      }),
      tenantTheme: {},
      tenantEmail: {
        defaults: {}
      },
      termsAndConditions: {},
      termsAndConditionsVisible: false,
      requestConsentTermsAndConditions: true,
      togglePositionTC: false,
      customEmailsVisible: false,
      useCustomEmail: false,
      emailTplVariables: templateVariables,
      feedback: {},
      scopeId: 0
    };
  },
  computed: {
    headerBG: function headerBG() {
      return './img/dtwin-factory1.png';
    },
    drawerIconLinks: function drawerIconLinks() {
      var _this = this;

      return routerPaths.filter(function (item) {
        return (item.meta || {}).isDrawerIconLink;
      }).map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          name: _this.$i18n_t(item.meta.i18n)
        });
      });
    },
    hasDomains: function hasDomains() {
      return this.tenantTheme.domains.length > 0;
    },
    emailRules: function emailRules() {
      var _this2 = this;

      return [function (v) {
        return !!v || _this2.$i18n_t('Common.fieldRequired');
      }, function (v) {
        return /.+@.+\..+/.test(v) || _this2.$i18n_t('Common.emailValid');
      }];
    },
    togglePositionTCC: function togglePositionTCC() {
      return this.togglePositionTC;
    },
    bgPositionItems: function bgPositionItems() {
      return [{
        value: 'left',
        text: this.$i18n_t('accMgmt.system.theme.positions.left')
      }, {
        value: 'right',
        text: this.$i18n_t('accMgmt.system.theme.positions.right')
      }, {
        value: 'center',
        text: this.$i18n_t('accMgmt.system.theme.positions.center')
      }, {
        value: 'center-overlap',
        text: this.$i18n_t('accMgmt.system.theme.positions.center-overlap')
      }];
    }
  },
  watch: {
    selectedTenantId: function () {
      var _selectedTenantId = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var tenant;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.selectedTenantId === undefined)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                tenant = this.getTenantById(this.selectedTenantId);
                this.tenantTheme = tenant.data && tenant.data.theme || {};
                this.tenantTheme = mergeWith(cloneDeep(this.themeDefaults), this.tenantTheme, mergeWithReplaceArrays);

                if (tenant.data.email) {
                  this.tenantEmail = tenant.data.email;
                }

                this.termsAndConditions = tenant.properties && tenant.properties.termsAndConditions ? tenant.properties.termsAndConditions : {
                  title: {
                    de: '',
                    en: ''
                  }
                };
                this.togglePositionTC = this.termsAndConditions && this.termsAndConditions.de && this.termsAndConditions.en ? true : false;
                this.useCustomEmail = get(tenant, 'data.feedback') ? true : false;
                this.requestConsentTermsAndConditions = true;
                this.termsAndConditionsVisible = this.togglePositionTC;
                this.customEmailsVisible = this.useCustomEmail;
                this.tenantEmail.siteUrl = this.getDomainSelected();
                this.loadEmailTemplates(this.selectedTenantId);
                this.scopeId = tenant.scopeId;
                this.feedback = get(tenant, 'data.feedback') || {};

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function selectedTenantId() {
        return _selectedTenantId.apply(this, arguments);
      }

      return selectedTenantId;
    }()
  },
  mounted: function mounted() {
    this.loadTenants();
  },
  methods: {
    fullImageUrl: function fullImageUrl(item) {
      if (item && item.startsWith(process.env.VUE_APP_API_PATH)) {
        item = "".concat(process.env.VUE_APP_API_HOST).concat(item);
      }

      return item;
    },
    isDefaultLogo: function isDefaultLogo(item) {
      return item === themeDefaults.lightLogo || item === themeDefaults.darkLogo;
    },
    getDomains: function getDomains() {
      return this.tenantTheme.domains.length === 0 ? [this.tenantEmail.defaults.siteUrl] : this.tenantTheme.domains;
    },
    getDomainSelected: function getDomainSelected() {
      if (this.tenantEmail.siteUrl && this.tenantTheme.domains.includes(this.tenantEmail.siteUrl)) {
        return this.tenantEmail.siteUrl;
      }

      return this.tenantTheme.domains.length === 0 ? this.tenantEmail.defaults.siteUrl : this.tenantTheme.domains[0];
    },
    revalidateForm: function revalidateForm() {
      this.$refs.mainForm.validate();
    },
    convertTemplateKey: function convertTemplateKey(key) {
      return kebabCaseToCamelCase(key);
    },
    checkPermissions: function checkPermissions(permissionSet, userPermissions) {
      var _this3 = this;

      // {
      //   or: [
      //     {and: [
      //       { subject: 'DigitalTwin', action: 'manage' },
      //       { subject: 'AutoID', action: 'read', inverted: true }
      //     ]},
      //     { subject: 'all', action: 'manage' }
      //   ]
      // }
      if (permissionSet.or && Array.isArray(permissionSet.or)) {
        return permissionSet.or.find(function (permission) {
          return _this3.checkPermissions(permission, userPermissions);
        });
      } else if (permissionSet.and && Array.isArray(permissionSet.and)) {
        return permissionSet.and.every(function (permission) {
          return _this3.checkPermissions(permission, userPermissions);
        });
      }

      var hasPermission = userPermissions["".concat(permissionSet.subject, ".").concat(permissionSet.action)];
      return hasPermission === !permissionSet.inverted;
    },
    loadEmailTemplates: function loadEmailTemplates(tenantId) {
      var _this4 = this;

      ApiService.getAllEmailTemplates(tenantId).then(function (data) {
        var allowedTemplates = emailTemplatesOrder.filter(function (item) {
          if (item.permissions) {
            return _this4.checkPermissions(item.permissions, _this4.permissions);
          }

          return true;
        });
        var templates = allowedTemplates.reduce(function (acc, cur) {
          return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, cur.template, {
            subject: data[cur.template].subject.de,
            html: data[cur.template].html.de
          }));
        }, []);
        _this4.emailTemplates = templates;
      }).catch(function (error) {
        console.error(error);
      });
    },
    updateLightBackground: function updateLightBackground(file) {
      this.imageUploads['lightBackground'] = file;
    },
    updateDarkBackground: function updateDarkBackground(file) {
      this.imageUploads['darkBackground'] = file;
    },
    updateLightLogo: function updateLightLogo(file, orientation) {
      this.tenantTheme.lightLogoOrientation = orientation;
      this.imageUploads['lightLogo'] = file;
    },
    updateDarkLogo: function updateDarkLogo(file, orientation) {
      this.tenantTheme.darkLogoOrientation = orientation;
      this.imageUploads['darkLogo'] = file;
    },
    updateFavicon: function updateFavicon(file, orientation) {
      var validImageFileName = /\.png$/i.exec(file.name);

      if (!validImageFileName) {
        this.$refs['favicon'].resetThumbnail();
        this.$snack(this.$i18n_t('accMgmt.system.theme.pngImagesAllowed'), 'error');
        return;
      }

      if (orientation !== 'square') {
        this.$refs['favicon'].resetThumbnail();
        this.$snack(this.$i18n_t('accMgmt.system.theme.squareImagesAllowed'), 'error');
        return;
      }

      this.imageUploads['favicon'] = file;
    },
    setPrimaryColorLight: function setPrimaryColorLight(color) {
      this.tenantTheme.lightHighlight = color === 'customerColor' ? 'customerColorLight' : color;

      if (color !== 'customerColor') {
        delete this.tenantTheme.lightHighlightCustomer;
      }
    },
    setPrimaryColorLightCustomer: function setPrimaryColorLightCustomer(hex) {
      this.tenantTheme.lightHighlight = 'customerColorLight';
      this.tenantTheme.lightHighlightCustomer = hex;
    },
    setPrimaryColorDark: function setPrimaryColorDark(color) {
      this.tenantTheme.darkHighlight = color === 'customerColor' ? 'customerColorDark' : color;

      if (color !== 'customerColor') {
        delete this.tenantTheme.darkHighlightCustomer;
      }
    },
    setPrimaryColorDarkCustomer: function setPrimaryColorDarkCustomer(hex) {
      this.tenantTheme.darkHighlight = 'customerColorDark';
      this.tenantTheme.darkHighlightCustomer = hex;
    },
    updateTemplate: function updateTemplate(key, part, content) {
      if (this.emailTemplates[key] && content !== '') {
        if (part === 'subject') {
          this.emailTemplates[key].subject = content;
        } else if (part === 'body') {
          this.emailTemplates[key].html = content;
        }
      }
    },
    saveEmailTemplate: function saveEmailTemplate(template, templateKey, tenantId) {
      var _this5 = this;

      return ApiService.setEmailTemplate(tenantId, templateKey, template).then(function (data) {
        _this5.emailTemplates[data.identifier] = {
          subject: data.template.subject.de,
          html: data.template.html.de
        };
      });
    },
    resetTheme: function resetTheme() {
      // reset potentially updated thumbnail on the theme image components src
      // check for refs existence because the components for the dark variations
      // are not rendered until their v-tab was activated once
      this.$refs['lightBackground'] && this.$refs['lightBackground'].resetThumbnail();
      this.$refs['darkBackground'] && this.$refs['darkBackground'].resetThumbnail();
      this.$refs['lightLogo'] && this.$refs['lightLogo'].resetThumbnail();
      this.$refs['darkLogo'] && this.$refs['darkLogo'].resetThumbnail();
      this.$refs['favicon'] && this.$refs['favicon'].resetThumbnail(); // clear potentially assigned theme image uploads

      this.imageUploads = []; // reset theme settings to default

      this.tenantTheme = Object.assign(this.tenantTheme, {
        darkBackground: themeDefaults.darkBackground,
        darkHighlight: themeDefaults.darkHighlight,
        darkLogo: themeDefaults.darkLogo,
        darkLogoByline: themeDefaults.darkLogoByline,
        darkLogoOrientation: themeDefaults.darkLogoOrientation,
        darkLogoPosition: themeDefaults.darkLogoPosition,
        lightBackground: themeDefaults.lightBackground,
        lightHighlight: themeDefaults.lightHighlight,
        lightLogo: themeDefaults.lightLogo,
        lightLogoByline: themeDefaults.lightLogoByline,
        lightLogoOrientation: themeDefaults.lightLogoOrientation,
        lightLogoPosition: themeDefaults.lightLogoPosition,
        favicon: themeDefaults.favicon
      });
    },
    saveTheme: function saveTheme() {
      var _this6 = this;

      var emailTemplatePromises = Object.keys(this.emailTemplates).map(function (tplKey) {
        var template = {
          subject: {
            de: _this6.emailTemplates[tplKey].subject
          },
          html: {
            de: _this6.emailTemplates[tplKey].html
          }
        };
        return _this6.saveEmailTemplate(template, tplKey, _this6.selectedTenantId);
      });
      this.isSaving = true;
      var uploadPromises = Object.keys(this.imageUploads).map(function (key) {
        return _this6.uploadImage(_this6.imageUploads[key]).then(function (fileId) {
          return {
            key: key,
            url: "".concat(process.env.VUE_APP_API_PATH, "/upload/").concat(fileId)
          };
        });
      });
      Promise.all(emailTemplatePromises).catch(function (error) {
        console.error(error);

        if (error.response && _this6.$i18n_t("Error.".concat(error.response.data.message))) {
          _this6.$snack(_this6.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this6.$snack(_this6.$i18n_t('accMgmt.system.errorSave'), 'error');
        }
      });
      Promise.all(uploadPromises).then(function (result) {
        result.forEach(function (item) {
          _this6.tenantTheme[item.key] = item.url;
        });
      }).then(function () {
        _this6.imageUploads = []; // Actually update the tenant

        return ApiService.tenantGetById(_this6.selectedTenantId, ['no-scope-descendents']);
      }).then(function (result) {
        var tenantObj = result;

        if (!tenantObj.data) {
          tenantObj.data = {};
        }

        tenantObj.data.theme = _this6.tenantTheme;
        tenantObj.data.email = _this6.tenantEmail;

        if (_this6.useCustomEmail) {
          set(tenantObj, 'data.feedback', _this6.feedback);
        } else {
          set(tenantObj, 'data.feedback', null);
        }

        if (!tenantObj.properties) {
          tenantObj.properties = {};
        }

        tenantObj.properties.termsAndConditions = _this6.termsAndConditionsVisible ? _this6.termsAndConditions : null;
        tenantObj.requestConsentTermsAndConditions = _this6.termsAndConditionsVisible && _this6.requestConsentTermsAndConditions ? true : false;
        return ApiService.tenantUpdate(_this6, result);
      }).then(function () {
        // store saved theme data to tenant state
        var tenantIdx = _this6.getTenantIdxById(_this6.selectedTenantId);

        if (!_this6.tenants[tenantIdx].properties) {
          _this6.tenants[tenantIdx].properties = {};
        }

        _this6.tenants[tenantIdx].data.theme = _this6.tenantTheme;
        _this6.tenants[tenantIdx].data.email = _this6.tenantEmail;
        _this6.tenants[tenantIdx].properties.termsAndConditions = _this6.termsAndConditions;
        _this6.isSaving = false;

        _this6.$snack(_this6.$i18n_t('accMgmt.system.saveSucess'), 'success');
      }).catch(function (error) {
        console.error(error);

        if (error.response && _this6.$i18n_t("Error.".concat(error.response.data.message))) {
          _this6.$snack(_this6.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this6.$snack(_this6.$i18n_t('accMgmt.system.errorSave'), 'error');
        }

        _this6.isSaving = false;
      });
    },
    uploadImage: function uploadImage(file) {
      var formData = new FormData();
      formData.append('file', file);
      return ApiService.saveFile(this, formData).then(function (result) {
        return result.fileId;
      });
    },
    reverseVisibility: function reverseVisibility() {
      this.termsAndConditionsVisible = !this.termsAndConditionsVisible;
    },
    reverseVisibilityCustomEmails: function reverseVisibilityCustomEmails() {
      this.customEmailsVisible = !this.customEmailsVisible;
    }
  }
};